import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    dark: true,
    themes: {
      dark: {
        primary: '#0023F5',
        accent: '#87DDDB',
      },
      light: {
        primary: '#0023F5',
        accent: '#87DDDB',
      }
    }
  }
});
